export const DATE_PICKER_TYPE = {
    DATE_FROM: 'fromDate',
    DATE_UNTIL: 'untilDate',
} as const;
export default DATE_PICKER_TYPE;
